module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"selected_period":"Selected Period","compared_period":"Compared Period","filter":"Filter","ok":"Ok","cancel":"Cancel","from":"From","to":"To"}}')
  delete Component.options._Ctor
}
